export default {
  id: 47,
  title: 'Target #47 - Corona Virus',
  url: 'https://cssbattle.dev/play/47',
  colors: ['#1A4341', '#F3AC3C', '#998235'],
  solution:
    '<a a><a b><a c><a d><a e><style>body{background:#1A4341}a{position:fixed;background:#F3AC3C}a[a],a[b],a[c]{width:10;height:180;border-radius:5px}a[a]{top:50;left:195}a[b]{top:55;right:186;transform:rotate(60deg)}a[c]{top:65;right:186;transform:rotate(-60deg)}a[d],a[e]{border-radius:50%}a[d]{top:100;left:150;width:100;height:100}a[e]{top:120;left:170;width:30;height:30;background:#998235;box-shadow:40px -10px 0 -10px #998235,15px 40px 0 -5px #998235}</style>',
}
